import { useCallback, useEffect, useRef, useState } from "react";

const DEFAULT_DURATION = 1400;

export default function useCopyFeedback(duration = DEFAULT_DURATION) {
  const [copiedKeys, setCopiedKeys] = useState({});
  const timersRef = useRef({});

  const markCopied = useCallback(
    (key) => {
      if (!key) return;
      setCopiedKeys((current) => ({ ...current, [key]: true }));

      if (timersRef.current[key]) {
        clearTimeout(timersRef.current[key]);
      }

      timersRef.current[key] = setTimeout(() => {
        setCopiedKeys((current) => ({ ...current, [key]: false }));
      }, duration);
    },
    [duration],
  );

  const copyWithFeedback = useCallback(
    async (key, text) => {
      await navigator.clipboard.writeText(text || "");
      markCopied(key);
      return true;
    },
    [markCopied],
  );

  useEffect(
    () => () => {
      Object.values(timersRef.current).forEach((timerId) => {
        clearTimeout(timerId);
      });
    },
    [],
  );

  return {
    copiedKeys,
    isCopied: (key) => Boolean(copiedKeys[key]),
    markCopied,
    copyWithFeedback,
  };
}

